import { render, staticRenderFns } from "./chart5.vue?vue&type=template&id=3fba63a0"
import script from "./chart5.vue?vue&type=script&lang=js"
export * from "./chart5.vue?vue&type=script&lang=js"
import style0 from "./chart5.vue?vue&type=style&index=0&id=3fba63a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports